import React from 'react';
import styles from './style.module.scss';
import { useTranslation } from 'next-i18next';
import { LOCALE_COMMON_PATHS, Namespaces } from 'types/locales';

function ContactForPrice({ onClick }: { onClick: () => void }) {
  const { t } = useTranslation(Namespaces.COMMON);

  return (
    <span className={styles['contact-for-price']} onClick={onClick}>
      {t(LOCALE_COMMON_PATHS.PRICE_HISTORY_CONTACT_FOR_PRICE)}
    </span>
  );
}

export default ContactForPrice;